import { Button } from "@/components/ui/button";
import { ColumnDef } from "@tanstack/react-table";
import { PhoneIcon } from "lucide-react";
import { useTheme } from "@/themeConfigs/ThemeContext";
import i18n from "@/lang/i18n";
import { CarDetailsTable } from "@/central-atoms/everest-fleet-pwa/types";
import { DataTableColumnHeader } from "@/components/custom/DataTableColumnHeader"; // Adjust the import path as needed

// Table columns definition
export const useCarDetailsTableColumns = (): ColumnDef<CarDetailsTable>[] => {
  const { theme } = useTheme();

  return [
    {
      accessorKey: "et_id",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={`${i18n.t("etID")}`}
          className="w-24"
        />
      ),
    },
    {
      accessorKey: "vehicle_number",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={`${i18n.t("vehicleNumber")}`}
          className="w-24"
        />
      ),
    },
    {
      accessorKey: "phone",
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={`${i18n.t("pilotNumber")}`}
          className="w-24"
        />
      ),
      cell: ({ row }) => (
        <div className="flex justify-center">
          <Button
            variant="icon"
            onClick={() => {
              window.open(`tel:${row.original.phone}`, "_blank");
            }}
            className="rounded-full"
          >
            <PhoneIcon
              fill={theme.colors.primary}
              size={20}
              strokeWidth={0.5}
            />
          </Button>
        </div>
      ),
    },
  ];
};
